export default __webpack_public_path__ + "static/guided-testing-9e047be74e513cb43497334b1976e148.png";